import db from '@/plugins/dexie';
import apirecebimentoweb from '@/services/api-recebimentoweb';
import moment from 'moment-timezone';
import geraData, { geraDataNuvem } from '../geradata';

import { testarConexaoApi } from '../isonline';
import { SetupEnvioLocal } from '../atualizalocal';

import { getVideoBlob } from './apontamentoVideoBlobs';

function extraiBearerToken(tokenString) {
  if (!tokenString) return '';
  try {
    const tokenObj = JSON.parse(tokenString);
    return tokenObj?.token || tokenObj;
  } catch (e) {
    return tokenString;
  }
}

export function montaPayloadApontamento(item, isUpdate = false) {
  let dataFallback = geraData();
  if (item.apedata) {
    dataFallback = geraData(item.apedata) || item.apedata;
  }
  let dataAlt = geraDataNuvem();
  if (!isUpdate && item.apedataalteracao) {
    dataAlt = geraDataNuvem(item.apedataalteracao);
  }
  const dataNuv = item.apedatanuvem ? geraDataNuvem(item.apedatanuvem) : dataAlt;

  const payload = {
    apeidapontamentoembarque: item.apeidapontamentoembarque ?? null,
    apetipomidia: item.apetipomidia ?? null,
    apedata: item.apedata || dataFallback,
    apeidplaca: item.apeidplaca ?? null,
    apeplaca: item.apeplaca ?? null,
    apeidmotorista: item.apeidmotorista ?? null,
    apemotorista: item.apemotorista ?? null,
    apecontratomp: item.apecontratomp ?? null,
    apeidprodutor: item.apeidprodutor ?? null,
    apeprodutor: item.apeprodutor ?? null,
    apeidpropriedade: item.apeidpropriedade ?? null,
    apepropriedade: item.apepropriedade ?? null,
    apeidproduto: item.apeidproduto ?? null,
    apeproduto: item.apeproduto || item.produto || null,
    apeidtalhao: item.apeidtalhao ?? null,
    apetalhao: item.apetalhao ?? null,
    apeiddestino: item.apeiddestino ?? null,
    apedestino: item.apedestino ?? null,
    apeobservacao: item.apeobservacao ?? null,
    apelatitude: item.apelatitude ?? null,
    apelongitude: item.apelongitude ?? null,
    apeidempresa: item.apeidempresa ?? null,
    apedatanuvem: dataNuv,
    apedataalteracao: dataAlt,
    apeidapontamentonuvem: item.apeidapontamentonuvem ?? null,
  };

  if (isUpdate) {
    const idNuvem = item.apeidapontamentonuvem || item.apeidnuvem;
    if (idNuvem) {
      payload.id = idNuvem;
    }
  }

  return payload;
}

function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n) {
    u8arr[n - 1] = bstr.charCodeAt(n - 1);
    n -= 1;
  }
  return new File([u8arr], filename, { type: mime });
}

async function enviaMidiasDoApontamento(item, targetIdNuvem, bearerToken) {
  if (!Array.isArray(item.fotos) || item.fotos.length === 0 || !targetIdNuvem) {
    return;
  }

  const fotosAtualizadas = [];
  let fotosModificadas = false;

  // eslint-disable-next-line no-restricted-syntax
  for (const foto of item.fotos) {
    const fotoAtualizada = { ...foto };

    if (!foto.enviado) {
      const isVideo = foto.tipo === 'video' || foto.blob || (typeof foto.url === 'string' && foto.url.startsWith('data:video'));

      if (isVideo) {
        let videoBlob = foto.blob || getVideoBlob(foto.id);
        if (!videoBlob && foto.url && foto.url.startsWith('blob:')) {
          try {
            // eslint-disable-next-line no-await-in-loop
            videoBlob = await fetch(foto.url).then((r) => r.blob());
          } catch (e) {
            // ignore
          }
        }

        if (videoBlob) {
          try {
            const formData = new FormData();
            const payloadMidia = {
              ...montaPayloadApontamento(item, true),
              id: targetIdNuvem,
              apeidapontamentonuvem: targetIdNuvem,
              apetipomidia: item.apetipomidia && item.apetipomidia.includes('image') ? 'image,video' : 'video',
            };
            formData.append('data', JSON.stringify(payloadMidia));
            formData.append('file', videoBlob, `${foto.nome || 'video'}.mp4`);

            // eslint-disable-next-line no-await-in-loop
            await apirecebimentoweb.post('/apontamentoembarque/video', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${bearerToken}`,
              },
            });
            fotoAtualizada.enviado = true;
            fotosModificadas = true;
          } catch (errVideo) {
            console.error('Erro ao enviar vídeo do apontamento:', errVideo.response?.data || errVideo.message || errVideo);
          }
        }
      } else {
        const rawUrl = foto.url || foto.src;
        if (rawUrl && typeof rawUrl === 'string' && rawUrl.startsWith('data:image')) {
          try {
            const file = dataURLtoFile(rawUrl, `${foto.nome || 'foto'}.jpg`);
            const formData = new FormData();
            const payloadMidia = {
              ...montaPayloadApontamento(item, true),
              id: targetIdNuvem,
              apeidapontamentonuvem: targetIdNuvem,
              apetipomidia: item.apetipomidia && item.apetipomidia.includes('video') ? 'image,video' : 'image',
            };
            formData.append('data', JSON.stringify(payloadMidia));
            formData.append('file', file);

            // eslint-disable-next-line no-await-in-loop
            await apirecebimentoweb.post('/apontamentoembarque/imagem', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${bearerToken}`,
              },
            });
            fotoAtualizada.enviado = true;
            fotosModificadas = true;
          } catch (errFoto) {
            console.error('Erro ao enviar imagem do apontamento:', errFoto.response?.data || errFoto.message || errFoto);
          }
        }
      }
    }

    fotosAtualizadas.push(fotoAtualizada);
  }

  if (fotosModificadas) {
    await db.apontamentoembarque.update(item.id, {
      fotos: fotosAtualizadas,
    });
  }
}

export default async function enviaApontamentoEmbarque(idLocal = null) {
  const conectou = await testarConexaoApi();
  if (!conectou) return;

  const tokenString = sessionStorage.getItem('auth:token') || sessionStorage.getItem('auth:tokenlocal');
  if (!tokenString) return;
  const bearerToken = extraiBearerToken(tokenString);

  let apontamentos = await db.apontamentoembarque.toArray();
  if (idLocal) {
    const idNum = Number(idLocal);
    apontamentos = apontamentos.filter(
      (m) => m.id === idLocal
        || m.id === idNum
        || m.apeidapontamentoembarque === idLocal
        || m.apeidapontamentoembarque === idNum,
    );
  } else {
    apontamentos = apontamentos.filter(
      (m) => !m.apedeletar
        && !m.apeenviado
        && !m.enviado
        && (
          (!m.apeidapontamentonuvem && !m.apeidnuvem)
          || !m.apedatanuvem
          || (m.apedataalteracao && m.apedatanuvem && moment(m.apedataalteracao).isAfter(moment(m.apedatanuvem)))
        ),
    );
  }

  if (apontamentos.length === 0) return;

  let houveAlteracao = false;

  for (const item of apontamentos) {
    const idNuvem = item.apeidapontamentonuvem || item.apeidnuvem;

    if (idNuvem) {
      console.log('put apontamentoembarque - ', item);
      const payload = montaPayloadApontamento(item, true);

      try {
        const res = await apirecebimentoweb.put(`/apontamentoembarque/${idNuvem}`, payload, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        });
        const dadosResp = Array.isArray(res.data) ? res.data[0] : (res.data?.data || res.data);
        const alteracao = geraDataNuvem(dadosResp?.apedataalteracao || dadosResp?.updated || new Date());
        const dataNuvem = geraDataNuvem(dadosResp?.apedatanuvem || dadosResp?.updated || alteracao);
        const idApontamentoFinal = dadosResp?.apeidapontamentoembarque
          || dadosResp?.id
          || item.apeidapontamentoembarque
          || null;

        await db.apontamentoembarque.update(item.id, {
          apeidapontamentonuvem: idNuvem,
          apeidnuvem: idNuvem,
          ...(idApontamentoFinal ? { apeidapontamentoembarque: idApontamentoFinal } : {}),
          apedataalteracao: alteracao,
          apedatanuvem: dataNuvem,
          apeenviado: 1,
          enviado: 1,
        });
        await enviaMidiasDoApontamento(item, idNuvem, bearerToken);
        houveAlteracao = true;
      } catch (err) {
        console.error('Erro ao atualizar apontamentoembarque:', err);
      }
    } else {
      console.log('post apontamentoembarque - ', item);
      const payload = montaPayloadApontamento(item, false);

      try {
        const res = await apirecebimentoweb.post('/apontamentoembarque', payload, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        });
        const dadosResp = Array.isArray(res.data) ? res.data[0] : (res.data?.data || res.data);
        const alteracao = geraDataNuvem(dadosResp?.apedataalteracao || dadosResp?.created || new Date());
        const dataNuvem = geraDataNuvem(dadosResp?.apedatanuvem || dadosResp?.created || alteracao);
        const idNuvemGerado = dadosResp?.id
          || dadosResp?.apeidapontamentonuvem
          || dadosResp?.apeidnuvem
          || dadosResp?.apeidapontamentoembarque
          || dadosResp?.insertId;
        const idApontamentoFinal = dadosResp?.apeidapontamentoembarque
          || dadosResp?.id
          || item.apeidapontamentoembarque
          || null;

        await db.apontamentoembarque.update(item.id, {
          apeidapontamentonuvem: idNuvemGerado,
          apeidnuvem: idNuvemGerado,
          apeidapontamentoembarque: idApontamentoFinal,
          apedataalteracao: alteracao,
          apedatanuvem: dataNuvem,
          apeenviado: 1,
          enviado: 1,
        });
        await enviaMidiasDoApontamento(item, idNuvemGerado, bearerToken);
        houveAlteracao = true;
      } catch (err) {
        console.error('Erro ao cadastrar apontamentoembarque:', err.response?.data || err.message || err);
      }
    }
  }

  if (houveAlteracao) {
    try {
      await SetupEnvioLocal({ silent: true });
    } catch (err) {
      console.warn('Aviso: Falha ao executar SetupEnvioLocal pós-envio de apontamento de embarque:', err);
    }
  }
}

export async function deletaApontamentoEmbarque() {
  const conectou = await testarConexaoApi();
  if (!conectou) return;

  const tokenString = sessionStorage.getItem('auth:token') || sessionStorage.getItem('auth:tokenlocal');
  if (!tokenString) return;
  const bearerToken = extraiBearerToken(tokenString);

  let registros = await db.apontamentoembarque.toArray();
  registros = registros.filter((m) => m.apedeletar || m.deletar);

  for (const item of registros) {
    const idNuvem = item.apeidapontamentonuvem || item.apeidnuvem;
    if (idNuvem) {
      try {
        await apirecebimentoweb.delete(`/apontamentoembarque/${idNuvem}`, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        });
      } catch (err) {
        console.error('Erro ao deletar apontamentoembarque na API:', err.response?.data || err.message || err);
      }
    }
    await db.apontamentoembarque.delete(item.id);
  }
}
